__turbopack_context__.v({
  "notice": "smsConsentNotice-module-scss-module__yZ2wva__notice",
});
